import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function PopUP(props) {
  const productName = props.category === "adalimumab" ? "Adalimumab-aaty" : props.category === "yuflyma" ? "Yuflyma" : props.category === "vegzelma" ? "Vegzelma" : props.category === "zymfentra" ? "Zymfentra" : props.category === "steqeyma" ? "Steqeyma" : "";
  const popupClassName = (props.category === "steqeyma" || props.category === "zymfentra") ? "steqeyma-popup" : "popup";
  const buttonCloseClassName = (props.category === "zymfentra") ? "theme-purple-btn" : "theme-btn";

  return (
    <>

        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className={popupClassName}
        >
          {(productName.toLowerCase() === "steqeyma" || productName.toLowerCase() === "zymfentra") && 
            <Modal.Body className="popup-padding">
                    <p>
                    Thank you for your interest in the<br />Celltrion CARES<sup className="reg">&reg;</sup> Co-pay Assistance Program.
                    </p>
                    <p>This program is offered by Celltrion USA to provide<br /> {productName.toUpperCase()}<sup className="reg">&reg;</sup> for eligible patients. We have reviewed the<br /> application and determined that the<br /> 
                    patient is not eligible to participate in the<br />Celltrion CARES Co-pay Assistance Program.
                    </p>
                    <p>If the patient’s situation changes, please notify the<br /> 
                    Celltrion CARES Co-pay Assistance Program, and<br /> 
                    we will be pleased to reassess the request.
                    </p>
                    <p>If you have any questions and would like to further discuss<br />
                    this decision, please don’t hesitate to contact us<br /> 
                    at 1-877-81CONNC (1-877-812-6662),<br /> 
                    Monday-Friday, 8 <span style={{fontSize: "16px"}}>AM</span> - 8 <span style={{fontSize: "16px"}}>PM</span> ET.
                    </p>

            </Modal.Body>
          } 
           {(productName.toLowerCase() !== "steqeyma" && productName.toLowerCase() !== "zymfentra" ) && 
          <Modal.Body className="popup-padding">
            <p>
              Thank you for your interest in the Celltrion CARES<sup>&reg;</sup>{" "}
              Co-pay Assistance Program.
            </p>
            <p>
              This program is offered by Celltrion USA to provide {productName}
              {props.category === "adalimumab" ? "" : props.category === "zymfentra" ? <><sup>&trade;</sup></> : <><sup>&reg;</sup></>} {" "}
              for eligible patients. We have reviewed the application and
              determined that the patient is not eligible to participate in the
              Celltrion CARES<sup>&reg;</sup> Co-pay Assistance Program.
            </p>
            <p>
              If the patient's situation changes, please notify the Celltrion CARES<sup>&reg;</sup> Co-pay
              Assistance Program and we will be pleased to reassess the request.
            </p>
            <p>
              If you have any questions and would like to further discuss this
              decision, please don’t hesitate to contact us at 1-877-81CONNC
              (1-877-812-6662), 8 AM-8 PM ET, Monday - Friday.
            </p>
          </Modal.Body>
          }
          <Modal.Footer className="popup-footer">
            <Button className={buttonCloseClassName} onClick={props.onHide}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      
    </>
  );
}
export default PopUP;